import { Component } from "react";
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    ScrollView,
    Linking,
    TextInput
} from "react-native";

// import ActionSheet from 'react-native-actionsheet';

import moment from "moment";
import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Text from "../components/Text";
import * as Constants from "../utils/Constants";
import * as Animatable from "react-native-animatable";
import * as ServerOperations from "../utils/ServerOperations";
// import Clipboard from "@react-native-clipboard/clipboard";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let styles = {};
let isMobile = false;
let scale = 1;
const imgAccountDetails = require("../images/Profile/AccountDetails.png");
const imgUnion = require("../images/Profile/Union.png");
const imgPen = require("../images/Profile/Pen.png");
const imgUpdateDetails = require("../images/Profile/UpdatingAccountDetails.png");
const imgVector = require("../images/Profile/vector.png");
const imgClosePopup = require("../images/Profile/closeIcon.png");
const imgCopy = require("../images/Profile/copy.png");
// import * as ImagePicker from 'expo-image-picker';
class Profile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showOrderDetails: false,
            showProfilePopUp: false,
            showProfilePopUpDesktop: true,
            selectedImage: imgUnion,
            accountInfo: {},
            fileToUpload: false,
            filename: "",
            userImage: "",
            isOther: false,

        };
    }
    Pressables = {};

    async componentDidMount() {
        const accountInfo = await ServerOperations.getUserInfo();
        if (accountInfo) {
            this.setState({ accountInfo, userImage: accountInfo.IMGURL });
        }
    }


    renderHeaderMobile = () => {
        var otherOpacity = 1;
        if (this.state.isOther) {
            otherOpacity = 0.3;
        }
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', padding: 20, alignSelf: "stretch", justifyContent: "space-between", opacity: otherOpacity }}>
                {/* <TouchableOpacity onPress={() => window.history.back()}>
                    <Image source={imgJdsLogo} style={{
                        width: 35.063,
                        height: 37,
                        padding: 1,
                        resizeMode: "contain",
                    }} />
                </TouchableOpacity> */}
                <View></View>
                {this.state.accountInfo.NAME &&
                    <Text style={[AppStyles.H2Styles, { textAlign: 'center', width: width - 130 },
                    this.state.accountInfo.NAME.length > 30 && { fontSize: 18 },
                    this.state.accountInfo.NAME.length > 40 && { fontSize: 16 },
                    ]}>
                        {this.state.accountInfo.NAME}
                    </Text>
                }
                <View></View>
                {/* <TouchableOpacity onPress={() => this.setState({ showModal: true })}>
                    <Image source={imgProfile} style={{ width: 20, height: 20, stroke: Styles.appColor1 }}></Image>
                </TouchableOpacity> */}
            </View>
        )
    }


    renderMobile() {
        scale = width / 420;
        var otherOpacity = 1;
        if (this.state.isOther) {
            otherOpacity = 0.3;
        }
        return (
            <View style={styles.container}>
                {this.renderHeaderMobile()}
                <ScrollView
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                    <View style={{ width, opacity: otherOpacity }}>
                        {Commons.loadFonts(this, false)}
                        {Styles.renderVSeparator(0)}
                        {this.renderPart1Mobile()}
                        {this.state.showProfilePopUp == true && this.renderProfileInfoPopUpMobile()}
                        {Styles.renderVSeparator(25)}
                        {/* {Commons.renderFooter({}, this)} */}
                    </View>
                </ScrollView >
                {this.state.isOther && Commons.renderOtherView(this)}
                {Commons.renderAppFooter({}, this, '', '', '', '#52C0EE')}
            </View >
        );
    }


    render() {
        width = Dimensions.get("window").width;
        isMobile = Commons.isMobile();
        styles = this.styles();
        if (isMobile) {
            Commons.resizeHandle(window, this, () => {
                width = this.width;
                height = this.height;
            });
            return this.renderMobile();
        }

        if (!this.props.self) {
            window.location = './ClientHomePage?tab=' + STRINGS.Profile;
            return;
        }

        width = (Commons.getDesktopWidth());
        height = (Commons.getDesktopHeight());
        styles = this.styles();
        if (width < 900) {
            return (
                <View style={styles.container}>
                    {this.renderHeaderMobile()}
                    <ScrollView
                        ref={ref => this.mainScrollView = ref}
                        scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                        <View style={{ width }}>
                            {Styles.renderVSeparator(0)}
                            {this.renderPart1Mobile()}
                            {this.state.showProfilePopUp == true && this.renderProfileInfoPopUpMobile()}
                            {Styles.renderVSeparator(25)}
                        </View>
                    </ScrollView >
                </View >
            );
        }
        return (
            <ScrollView
                ref={ref => this.mainScrollView = ref}
                scrollEventThrottle={200} showsVerticalScrollIndicator={false}
                onScroll={(e) => Commons.onHeaderScroll(e, this)}
                style={{ width, backgroundColor: AppStyles.desktopBackgroundColor, height }}
            >

                <View style={{ width }}>
                    <View style={{
                        flexGrow: 1, flexDirection: 'column', gap: 16, paddingHorizontal: 50,
                    }}>

                        <View style={{ alignItems: 'center', gap: 8, flexDirection: "row", marginTop: 80 }}>
                            <Text style={[AppStyles.H2Styles]}>{STRINGS.Account_Details_Profile}</Text>
                            {/* <TouchableOpacity onPress={() => this.setState({ showProfilePopUp: true })}>
                            <Image source={imgAccountDetails} style={{ width: 15, height: 15 }} />
                        </TouchableOpacity> */}
                        </View>
                        {/* {this.state.showProfilePopUp == true && this.renderProfileInfoPopUp()} */}
                        {this.state.showProfilePopUpDesktop && this.renderProfileInfoPopUp()}
                        <View style={{ alignItems: 'flex-end', gap: 16, alignSelf: 'stretch', flexDirection: 'row', marginTop: 40 }}>
                            <View>
                                <Image source={this.state.userImage ? this.state.userImage : imgUnion} style={{ width: 88.866, height: 88.866, borderRadius: 360 }} />
                                <TouchableOpacity onPress={() => this.uploadImage()} style={{
                                    width: 32, height: 32, justifyContent: 'center', alignItems: 'center', borderRadius: 360, borderWidth: 2, borderColor: '#FFF', backgroundColor: '#52C0EE', position: 'absolute',
                                    top: 60, left: 58,
                                }}>
                                    <Image source={imgPen} style={{ width: 20, height: 20 }} />
                                </TouchableOpacity>
                            </View>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', gap: 32, width: 720 }}>
                                <View style={{ width: 238, flexDirection: 'column', alignItems: 'flex-start', gap: 8 }}>
                                    <Text style={[AppStyles.LabelTextStyles]}>Pharmacy name</Text>
                                    <TextInput style={[AppStyles.TextInputStyles1x, { width: 293, backgroundColor: '#fff' }]}
                                        placeholder={this.state.accountInfo.NAME}
                                        editable={false}>
                                    </TextInput>
                                </View>
                                <TouchableOpacity onPress={async () => {
                                    await Commons.resetUserInfo();
                                    await Commons.removeFromAS(Constants.TOKEN);
                                    window.location = './login';
                                }}>
                                    <Text style={[AppStyles.ButtonTextStyles]}>{STRINGS.profile_log_out}</Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                        <View style={{ flexGrow: 1, flexDirection: 'column', gap: 16 }}>
                            <View style={{ flexDirection: 'row', gap: 32 }}>
                                <View style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 8, alignSelf: 'stretch', backgroundColor: AppStyles.desktopBackgroundColor, marginTop: 10 }}>
                                    <Text style={[AppStyles.LabelTextStyles]}>{STRINGS.Registered_Phone_Number}</Text>
                                    <TextInput style={[AppStyles.TextInputStyles1x, { width: 400, backgroundColor: '#fff' }]}
                                        placeholder={this.state.accountInfo.PHONE}
                                        editable={false}>
                                    </TextInput>
                                </View>

                                <View style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 8, alignSelf: 'stretch', backgroundColor: AppStyles.desktopBackgroundColor, marginTop: 10 }}>
                                    <Text style={[AppStyles.LabelTextStyles]}>{STRINGS.Profile_Address}</Text>
                                    <TextInput style={[AppStyles.TextInputStyles1x, { width: 400, backgroundColor: '#fff' }]}
                                        placeholder={this.state.accountInfo.ADDRESS}
                                        editable={false}>
                                    </TextInput>
                                </View>
                            </View>

                            <View style={{ flexDirection: 'row', gap: 32 }}>
                                <View style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 8, alignSelf: 'stretch', backgroundColor: AppStyles.desktopBackgroundColor, marginTop: 10 }}>
                                    <Text style={[AppStyles.LabelTextStyles]}>{STRINGS.Account_Number}</Text>
                                    <TextInput style={[AppStyles.TextInputStyles1x, { width: 400, backgroundColor: '#fff' }]}
                                        placeholder={this.state.accountInfo.ACNO}
                                        editable={false}>
                                    </TextInput>
                                </View>

                                <View style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 8, alignSelf: 'stretch', backgroundColor: AppStyles.desktopBackgroundColor, marginTop: 10 }}>
                                    <Text style={[AppStyles.LabelTextStyles]}>{STRINGS.Authorized_Signee}</Text>
                                    <TextInput style={[AppStyles.TextInputStyles1x, { width: 400, backgroundColor: '#fff' }]}
                                        placeholder={this.state.accountInfo.AUTH}
                                        editable={false}>
                                    </TextInput>
                                </View>
                            </View>
                            <View style={{ flexDirection: 'row', gap: 32 }}>
                                <View style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 8, alignSelf: 'stretch', backgroundColor: AppStyles.desktopBackgroundColor, marginTop: 10 }}>
                                    <Text style={[AppStyles.LabelTextStyles]}>{STRINGS.Assigned_Sales_Rep}</Text>
                                    <TextInput style={[AppStyles.TextInputStyles1x, { width: 400, backgroundColor: '#fff' }]}
                                        placeholder={this.state.accountInfo.SALESMAN}
                                        editable={false}>
                                    </TextInput>
                                </View>
                                <View style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 8, alignSelf: 'stretch', backgroundColor: AppStyles.desktopBackgroundColor, marginTop: 10 }}>
                                    <Text style={[AppStyles.LabelTextStyles]}>{STRINGS.Sales_Rep_Phone}</Text>
                                    <View style={{ flexDirection: 'row', gap: 8 }}>
                                        <TextInput style={[AppStyles.TextInputStyles1x, { width: 400, backgroundColor: '#fff' }]}
                                            placeholder={this.state.accountInfo.SALESMAN_PHONE}
                                            editable={false}>
                                        </TextInput>
                                        <TouchableOpacity
                                            style={{ position: 'absolute', right: 0, top: 17, width: 30, height: 30 }}
                                            onPress={() => {
                                                // Clipboard.setString(this.state.accountInfo.SALESMAN_PHONE);
                                                Linking.openURL(`tel:${this.state.accountInfo.SALESMAN_PHONE}`);
                                            }}>
                                            <Image source={imgCopy} style={{ width: 19.2, height: 19.2 }} />
                                        </TouchableOpacity>
                                    </View>
                                </View>
                            </View>
                        </View>
                        {this.renderSalesmen()}
                    </View>
                </View>
            </ScrollView>
        );
    }

    renderSalesmenMobile = () => {
        if (!this.state.accountInfo.SALESMEN || this.state.accountInfo.SALESMEN.length === 0) {
            return null;
        }
        return (
            this.state.accountInfo.SALESMEN.map((salesman, index) => (
                [<View key={index} style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 8, alignSelf: 'stretch', marginTop: 10 }}>
                    <Text style={[AppStyles.LabelTextStyles]}>{salesman.TYPE}</Text>
                    <View style={{ flexDirection: 'row', gap: 8 }}>
                        <TextInput style={[AppStyles.TextInputStyles1x, { width: width - 40, color: Styles.appColor1 }]}
                            placeholder={salesman.NAME}
                            editable={false}>
                        </TextInput>
                    </View>
                </View>,
                <View key={index} style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 8, alignSelf: 'stretch', marginTop: 10 }}>
                    <Text style={[AppStyles.LabelTextStyles]}>{STRINGS.Sales_Rep_Phone}</Text>
                    <View style={{ flexDirection: 'row', gap: 8 }}>
                        <TextInput style={[AppStyles.TextInputStyles1x, { width: width - 40, color: Styles.appColor1 }]}
                            placeholder={salesman.MOBILE}
                            editable={false}>
                        </TextInput>
                        <TouchableOpacity
                            style={{ position: 'absolute', right: 0, top: 17, width: 30, height: 30 }}
                            onPress={() => Linking.openURL(`tel:${salesman.MOBILE}`)}>
                            <Image source={imgCopy} style={{ width: 19.2, height: 19.2 }} />
                        </TouchableOpacity>
                    </View>
                </View>]

            ))
        );
    }

    renderSalesmen = () => {
        if (!this.state.accountInfo.SALESMEN || this.state.accountInfo.SALESMEN.length === 0) {
            return null;
        }

        return (
            <View style={{ flexGrow: 1, flexDirection: 'column', gap: 16, }}>
                {/* <Text style={[AppStyles.H2Styles]}>Sales Representatives</Text> */}
                {this.state.accountInfo.SALESMEN.map((salesman, index) => (
                    <View key={index} style={{ flexDirection: 'row', gap: 32 }}>
                        <View style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 8, alignSelf: 'stretch', backgroundColor: AppStyles.desktopBackgroundColor, marginTop: 10 }}>
                            <Text style={[AppStyles.LabelTextStyles]}>{salesman.TYPE}</Text>
                            <TextInput style={[AppStyles.TextInputStyles1x, { width: 400, backgroundColor: '#fff' }]}
                                placeholder={salesman.NAME}
                                editable={false}>
                            </TextInput>
                        </View>
                        <View style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 8, alignSelf: 'stretch', backgroundColor: AppStyles.desktopBackgroundColor, marginTop: 10 }}>
                            <Text style={[AppStyles.LabelTextStyles]}>{STRINGS.Sales_Rep_Phone}</Text>
                            <View style={{ flexDirection: 'row', gap: 8 }}>
                                <TextInput style={[AppStyles.TextInputStyles1x, { width: 400, backgroundColor: '#fff' }]}
                                    placeholder={salesman.MOBILE}
                                    editable={false}>
                                </TextInput>
                                <TouchableOpacity
                                    style={{ position: 'absolute', right: 0, top: 17, width: 30, height: 30 }}
                                    onPress={() => {
                                        Linking.openURL(`tel:${salesman.MOBILE}`);
                                    }}>
                                    <Image source={imgCopy} style={{ width: 19.2, height: 19.2 }} />
                                </TouchableOpacity>
                            </View>
                        </View>
                    </View>
                ))}
            </View>
        );
    }

    uploadImage = () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.onchange = async (event) => {
            const file = event.target.files[0];
            if (file) {
                this.setState({
                    showPickedFile: true, PickedFileName: file.name, changableStyle: AppStyles.secondaryButtonStyles, changableTextStyle: AppStyles.AcitvateButtonTextStyles,
                    changableStyle2: AppStyles.secondaryButtonStyleOpacity, changableTextStyle2: AppStyles.loginButtonTextStyles, selectedImage: URL.createObjectURL(file),
                    userImage: URL.createObjectURL(file),
                    fileToUpload: file,
                });
                this.uploadImageMobile(file.name, file);
            }
        };
        input.click();
    }

    uploadImageMobile = async (fileName, file) => {
        const fileToUpload = file;
        const name = moment(new Date()).format('YYYYMMDDHHMMSS') + "_" + fileName;
        const response = await ServerOperations.pickUploadHttpRequest(fileToUpload, "profileImg\\" + name);
        this.setState({ filename: name });
        if (response === Constants.networkError_code) {
            this.setState({ uploaded: false });
            console.log("Network Error");
        }
        if (response.ok) {
            const resp = await response.json();
            this.setState({ fileToUpload: undefined, });
            console.log("Uploaded Successfully");
            this.postDataOnPick(name);
            return resp;
        }

    }

    postDataOnPick = async (fileName) => {
        const userImage = await ServerOperations.updateUserImage(fileName);
        console.log(userImage);
    }


    renderPart1 = () => {
    }

    renderPart1Mobile = () => {
        const ProfileInformation = [
            { label: STRINGS.Registered_Phone_Number, value: this.state.accountInfo.PHONE },
            { label: STRINGS.Profile_Address, value: this.state.accountInfo.ADDRESS },
            { label: STRINGS.Account_Number, value: this.state.accountInfo.ACNO },
            { label: STRINGS.Authorized_Signee, value: this.state.accountInfo.AUTH },
            { label: STRINGS.Assigned_Sales_Rep, value: this.state.accountInfo.SALESMAN },
            { label: STRINGS.Sales_Rep_Phone, value: this.state.accountInfo.SALESMAN_PHONE },
        ];
        return (
            <View style={{ width: width - 40, marginTop: 16, flexDirection: 'column', gap: 16, paddingHorizontal: 20 }}>
                <View style={{ width: width - 40, alignItems: 'center', justifyContent: 'space-between', flexDirection: 'row' }}>
                    <View style={{ alignItems: 'center', gap: 8, flexDirection: "row" }}>
                        <Text style={[AppStyles.H3Styles]}>{STRINGS.Account_Details_Profile}</Text>
                        <TouchableOpacity onPress={() => this.setState({ showProfilePopUp: true })}>
                            <Image source={imgAccountDetails} style={{ width: 15, height: 15 }} />
                        </TouchableOpacity>
                    </View>
                    <TouchableOpacity onPress={async () => {
                        await Commons.resetUserInfo();
                        await Commons.removeFromAS(Constants.TOKEN);
                        window.location = './login';
                    }}>
                        <Text style={[AppStyles.ButtonTextStyles]}>{STRINGS.profile_log_out}</Text>
                    </TouchableOpacity>
                </View>
                <View style={{ alignItems: 'flex-end', gap: 16, alignSelf: 'stretch', flexDirection: 'row' }}>
                    <View>
                        <Image source={this.state.userImage ? this.state.userImage : imgUnion} style={{ width: 88.866, height: 88.866, borderRadius: 360 }} />
                        <TouchableOpacity onPress={() => this.uploadImage()} style={{
                            width: 32, height: 32, justifyContent: 'center', alignItems: 'center', borderRadius: 360, borderWidth: 2, borderColor: '#FFF', backgroundColor: '#52C0EE', position: 'absolute',
                            top: 60, left: 58,
                        }}>
                            <Image source={imgPen} style={{ width: 20, height: 20 }} />
                        </TouchableOpacity>
                    </View>
                    <View style={{ width: 238, flexDirection: 'column', alignItems: 'flex-start', gap: 8 }}>
                        <Text style={[AppStyles.LabelTextStyles]}>Pharmacy name</Text>
                        <TextInput style={[AppStyles.TextInputStyles1x, { width: width - 145, color: Styles.appColor1 }]}
                            placeholder={this.state.accountInfo.NAME}
                            editable={false}>
                        </TextInput>
                    </View>
                </View>

                {ProfileInformation.map((item, index) => {
                    return (
                        <View key={index} style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 8, alignSelf: 'stretch', marginTop: 10 }}>
                            <Text style={[AppStyles.LabelTextStyles]}>{item.label}</Text>
                            <View style={{ flexDirection: 'row', gap: 8 }}>
                                <TextInput style={[AppStyles.TextInputStyles1x, { width: width - 40, color: Styles.appColor1 }]}
                                    placeholder={item.value}
                                    editable={false}>
                                </TextInput>
                                {index == 5 && (
                                    <TouchableOpacity
                                        style={{ position: 'absolute', right: 0, top: 17, width: 30, height: 30 }}
                                        onPress={() => Linking.openURL(`tel:${item.value}`)}>
                                        <Image source={imgCopy} style={{ width: 19.2, height: 19.2 }} />
                                    </TouchableOpacity>
                                )}
                            </View>
                        </View>
                    )
                })}
                {this.renderSalesmenMobile()}
            </View>
        )
    }

    renderProfileInfoPopUp = () => {
        return (
            <View style={{ width: 850, flexDirection: 'row', alignItems: 'center', gap: 16, alignSelf: 'stretch', borderRadius: 16, borderWidth: 1, borderColor: 'rgba(215, 215, 215, 0.50)' }}>
                <TouchableOpacity
                    onPress={() => this.setState({ showProfilePopUpDesktop: false })}
                    style={{
                        position: 'absolute',
                        top: 10,
                        right: 10,
                        width: 20,
                        height: 20,
                        backgroundColor: 'white',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Image source={imgClosePopup} style={{ width: 10, height: 10 }} />
                </TouchableOpacity>
                <View style={{ flexDirection: "row", gap: 16, alignItems: 'center', justifyContent: 'flex-start', alignSelf: 'stretch', marginHorizontal: 24, marginTop: 24, marginBottom: 24 }}>
                    <View style={{}}>
                        <Image source={imgVector} style={{ width: 110.115, height: 101.534 }} />
                        <Image source={imgUpdateDetails} style={{ width: 123, height: 93.433, position: 'absolute', top: 8 }} />
                    </View>
                    <View style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 16, alignSelf: 'stretch', justifyContent: 'flex-start', width: 490, }}>
                        <Text style={[AppStyles.H2Styles]}>{STRINGS.updating_Account_Details}</Text>
                        <Text style={[AppStyles.UpdatingAccountStyle, { textAlign: 'left' }]}>{STRINGS.Updating_Account_Text_Desktop}</Text>
                    </View>
                </View>
            </View>
        )

    }

    renderProfileInfoPopUpMobile = () => {
        return (
            <Animatable.View
                animation="slideInUp"
                duration={500}
                style={{
                    width: width,
                    height: '150%',
                    position: 'absolute',
                    top: '40%',
                    transform: [{ translateX: -(width - 20) / 2 }, { translateY: -237.5 }],
                    zIndex: 1000,
                    flexDirection: 'column',
                    backgroundColor: '#FFF',
                    alignItems: 'center',
                    gap: 32,
                    borderTopRightRadius: 16,
                    borderTopLeftRadius: 16,
                    borderWidth: 1,
                    borderColor: 'rgba(215, 215, 215, 0.50)',
                }}>
                <TouchableOpacity
                    onPress={() => this.setState({ showProfilePopUp: false })}
                    style={{
                        position: 'absolute',
                        top: 10,
                        right: 10,
                        width: 20,
                        height: 20,
                        borderRadius: 15,
                        backgroundColor: 'white',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderColor: Styles.appColor1,
                        borderWidth: 1,
                    }}
                >
                    <Text style={{ color: Styles.appColor1, fontSize: 10 }}>X</Text>
                </TouchableOpacity>
                <View style={{ marginTop: 50 }}>
                    <Image source={imgVector} style={{ width: 110.115, height: 101.534 }} />
                    <Image source={imgUpdateDetails} style={{ width: 123, height: 93.433, position: 'absolute', top: 8 }} />
                </View>
                <View style={{ flexDirection: 'column', alignItems: 'center', gap: 16, alignSelf: 'stretch' }}>
                    <Text style={[AppStyles.H2Styles]}>{STRINGS.updating_Account_Details}</Text>
                    <Text style={[AppStyles.UpdatingAccountStyle, { textAlign: 'center' }]}>{STRINGS.Updating_Account_Text}</Text>
                </View>
            </Animatable.View>
        )
    }


    styles = () => ({
        container: {
            flex: 1,
            width: width,
            alignItems: "center",
            backgroundColor: AppStyles.desktopBackgroundColor
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            width,
            height: 590,
        }
    });
}



export default Profile;
